import { useEffect, useState } from "react";
import { Alert, Box } from "@mui/material";
import CustomButton from "../../../../../components/common/button/CustomButton";
import Popup from "../../../../../components/common/model/Popup";
import Notification from "../../../../../components/common/notification/Notification";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../../../store/reducers/mmymSlice";
import ManageProfessionalConfirmation from "../../../IsProfessional/confirmation/ManageProfessionalConfirmation";
import useStyles from "../../../lead/confirmation/confirmationStyle";

interface ConfirmationTarget {
  leadId: string | number;
}

interface MoveOutStorageModalProps {
  open: boolean;
  contractTitle: string;
  removalLeadId?: string | number | null;
  serviceCheckResult: any;
  onClose: () => void;
  onGenerateFinalInvoice: () => void;
  onCheckService: () => void;
  onConfirmationSaved: (isNewLead: boolean) => void;
  rowSelected?:any;
}

const MoveOutStorageModal = ({
  open,
  contractTitle,
  removalLeadId,
  serviceCheckResult,
  rowSelected,
  onClose,
  onGenerateFinalInvoice,
  onCheckService,
  onConfirmationSaved,
}: MoveOutStorageModalProps) => {
  const [confirmFinalInvoice, setConfirmFinalInvoice] = useState(false);
  const [professionalConfirmation, setProfessionalConfirmation] =
    useState(false);
  const [newLeadConfirmation, setNewLeadConfirmation] = useState(false);
  const classes = useStyles({ professionalConfirmation });
  const [confirmationTarget, setConfirmationTarget] =
    useState<ConfirmationTarget | null>(null);
  const [serviceCheckError, setServiceCheckError] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!serviceCheckResult) return;

    if (serviceCheckResult.error || serviceCheckResult.success === false) {
      setServiceCheckError(
        serviceCheckResult.error ||
          serviceCheckResult.message ||
          "Service check failed.",
      );
      return;
    }

    const resultData = serviceCheckResult.data ?? serviceCheckResult;
    if (resultData?.isServiceExists === true) {
      if (!resultData.leadId) {
        setServiceCheckError(
          "The service check did not return a lead ID for the confirmation.",
        );
        return;
      }

      setServiceCheckError("");
      setConfirmationTarget({
        leadId: resultData.leadId,
      });
      setProfessionalConfirmation(true);
    } else if (resultData?.isServiceExists === false) {
      setServiceCheckError("");
      setNewLeadConfirmation(true);
    } else {
      setServiceCheckError("No confirmation details were returned.");
    }
  }, [serviceCheckResult]);

  const handleClose = () => {
    setConfirmFinalInvoice(false);
    setProfessionalConfirmation(false);
    setNewLeadConfirmation(false);
    setConfirmationTarget(null);
    setServiceCheckError("");
    onClose();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleProfessionalConfirmationClose = (show: boolean) => {
    if (!show) {
      setProfessionalConfirmation(false);
      setConfirmationTarget(null);
    }
  };

  const handleCreateNewLead = () => {
    setNewLeadConfirmation(false);
    onConfirmationSaved(true);
  };

  console.log("rowSelected",rowSelected);
  return (
    <>
      <Popup
        open={open && !confirmFinalInvoice && !professionalConfirmation}
        title="Move out of storage"
        onHide={handleClose}
        fullWidth
        maxWidth="sm"
        popupBg="#fff"
        footer={
          <>
            <CustomButton
              variant="outlined"
              title="Generate final invoice"
              onClick={() => setConfirmFinalInvoice(true)}
            />
            <CustomButton
              title="Move to job"
              disabled={!rowSelected?.is_final_invoice}
              onClick={onCheckService}
            />
          </>
        }
      >
        <Box sx={{ p: 2 }}>
          {serviceCheckError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {serviceCheckError}
            </Alert>
          )}
          Choose an action for {contractTitle}.
        </Box>
      </Popup>
      <Popup
        open={open && confirmFinalInvoice && !newLeadConfirmation}
        title="Generate final invoice"
        onHide={handleClose}
        fullWidth
        maxWidth="sm"
        popupBg="#fff"
        disableContentText
        footer={
          <>
            <CustomButton
              variant="outlined"
              title="No"
              onClick={handleClose}
            />
            <CustomButton title="Yes" onClick={onGenerateFinalInvoice} />
          </>
        }
      >
        <Notification />
        <br />
        Are you sure you want to generate final invoice?
      </Popup>
      <Popup
        open={open && newLeadConfirmation}
        title="Create new customer"
        onHide={() => setNewLeadConfirmation(false)}
        fullWidth
        maxWidth="sm"
        popupBg="#fff"
        disableContentText
        footer={
          <>
            <CustomButton
              variant="outlined"
              title="No"
              onClick={() => setNewLeadConfirmation(false)}
            />
            <CustomButton title="Yes" onClick={handleCreateNewLead} />
          </>
        }
      >
        <Alert severity="info" sx={{ m: 2 }}>
          No existing removal service was found. Do you want to create a new
          customer using the same data?
        </Alert>
      </Popup>
      {professionalConfirmation && confirmationTarget && (
        <section
          className={
            professionalConfirmation ? classes.estimatePopupOverlay : ""
          }
        >
          <ManageProfessionalConfirmation
            show={professionalConfirmation}
            setShow={handleProfessionalConfirmationClose}
            generateId={confirmationTarget.leadId}
            onConfirmationSaved={onConfirmationSaved}
          />
        </section>
      )}
    </>
  );
};

export default MoveOutStorageModal;